export * from "@frend-digital/next/i18n/client";
